// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-1db96842]{max-width:240px;background-color:#fff;height:100%}a[data-v-1db96842]{text-decoration:none}", ""]);
// Exports
module.exports = exports;
